module.exports = __webpack_public_path__ + "img/5_85.2d577eba.png";